import { DataVersion, UNIFIED_DATA_VERSION } from '@hakimo-ui/hakimo/types';

/**
 * Whether this request/link should go through the unified (v3) data path.
 *
 * Prefer this over a bare `dataVersion === 'v3'` so the one place that knows
 * which version is "the unified one" stays `UNIFIED_DATA_VERSION`.
 */
export function isUnifiedDataVersion(dataVersion?: DataVersion): boolean {
  return dataVersion === UNIFIED_DATA_VERSION;
}
